export function EmptyFolderText({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-gray-500 pl-[22px] py-[5px] font-geist text-[16px] leading-[20px] tracking-tight">
      {children}
    </div>
  );
}
